import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { AppConstant } from "./appConstant";



@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = localStorage.getItem(AppConstant.authToken);
    if (token) {
      req = req.clone({
        setHeaders: {
          'Accept': 'application/json',
          // 'Content-Type': 'application/json',
          'Authorization': 'bearer ' + token
        },
      });
    }
    return next.handle(req).pipe(
      finalize(() => { })
    );
  }
}
